(function() { window.GUID_6a566699_04ec_4fe9_824a_678353c891f2 = { getGuid: function() { return "6a566699-04ec-4fe9-824a-678353c891f2"; } }; })();
var CS;
(function (CS) {
    let CSS;
    (function (CSS) {
        let currentStylesLoadedCount = null;
        let stylesCountToTest = null;
        function ResetFileLoadedCount() {
            currentStylesLoadedCount = null;
            stylesCountToTest = null;
        }
        CSS.ResetFileLoadedCount = ResetFileLoadedCount;
        function FileLoaded() {
            if (!currentStylesLoadedCount) {
                currentStylesLoadedCount = 0;
            }
            currentStylesLoadedCount += 1;
            TryAllStylesLoaded();
        }
        CSS.FileLoaded = FileLoaded;
        function TryAllStylesLoaded() {
            if (stylesCountToTest && stylesCountToTest == currentStylesLoadedCount) {
                if (CS.Views.ViewBase.CurrentView) {
                    CS.Views.ViewBase.CurrentView.OnAllCssFilesLoaded();
                }
            }
        }
        CSS.TryAllStylesLoaded = TryAllStylesLoaded;
        function DetermineCssFilesCountToTest() {
            stylesCountToTest = CS.DOM.$sectionMaster.find('link').length;
            TryAllStylesLoaded();
        }
        CSS.DetermineCssFilesCountToTest = DetermineCssFilesCountToTest;
    })(CSS = CS.CSS || (CS.CSS = {}));
})(CS || (CS = {}));

//# sourceMappingURL=cs-css-files-loaded-helper.js.map
